import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from "../dynamicDataSet.module.config";
import { DynamicDataSetListModel } from '../models/DynamicDataSetListModel';
import { DynamicDataSetModel } from '../models/DynamicDataSetModel';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';

@Component({
  selector: 'brd-delete-dynamic-dataset-confirmation-dialog',
  templateUrl: './delete-dynamic-dataset-confirmation-dialog.component.html',
  styleUrls: ['./delete-dynamic-dataset-confirmation-dialog.component.scss']
})
export class DeleteDynamicDataSetConfirmationDialogComponent implements OnInit, OnDestroy {
  eventUnsubscribe: Subscription;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  name: string;
  key: string;
  deleteActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  constructor(
    public dialogRef: MatDialogRef<DynamicDataSetListModel>,
    private router: Router,
    private actions$: Actions,
    private dynamicDataSetTileStore: Store<TileState<DynamicDataSetListModel, DynamicDataSetModel>>,
    @Inject(MAT_DIALOG_DATA) public data: DynamicDataSetListModel) {
    this.name = data.name;
    this.key = data.key;
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.deleteSuccessType<DynamicDataSetListModel>(ModuleConfiguration.moduleName, DynamicDataSetListModel))
      .subscribe((a: actions.DeleteSuccessAction<DynamicDataSetListModel>) => {
        var inTileView = this.router.url.includes('configuration');
        if (inTileView) {
          this.dynamicDataSetTileStore.dispatch(new actions.QueryListAction(ModuleConfiguration.moduleName,
            DynamicDataSetListModel,
            {
              page: 0,
              pageSize: 20,
            }));
        } else {
          this.router.navigateByUrl('/configuration');
        }
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.deleteActionIdentifier && a.payload.action.identifier === this.deleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }
  delete() {
    var model = this.data;
    var deleteAction = new actions.DeleteAction(ModuleConfiguration.moduleName, DynamicDataSetListModel, { model: model });
    this.deleteActionIdentifier = deleteAction.identifier;
    this.dynamicDataSetTileStore.dispatch(deleteAction);
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/components/delete-dynamic-dataset-confirmation-dialog.component.ts